// 同步控制屏

const recvMap = {
  // DG1调速开关 降
  1: {
    key: "DG1SpeedSwitchLower",
    nodeId: "knob_K07_1",
    targetId: "mainPowerGrid",
    mode: "LOWER",
    currentCommand: "SyncScreenAndCommunication/switch/DG1",
    state: {
      // 0代表不在此位置
      0: false,
      // 1代表旋转到此位置
      1: true,
    },
  },
  // DG1调速开关 升
  2: {
    key: "DG1SpeedSwitchRaise",
    nodeId: "knob_K07_1",
    targetId: "mainPowerGrid",
    mode: "RAISE",
    currentCommand: "SyncScreenAndCommunication/switch/DG1",
    state: {
      0: false,
      1: true,
    },
  },
  // DG2调速开关 降
  3: {
    key: "DG2SpeedSwitchLower",
    nodeId: "knob_K07_2",
    targetId: "mainPowerGrid",
    mode: "LOWER",
    currentCommand: "SyncScreenAndCommunication/switch/DG2",
    state: {
      0: false,
      1: true,
    },
  },
  // DG2调速开关 升
  4: {
    key: "DG2SpeedSwitchRaise",
    nodeId: "knob_K07_2",
    targetId: "mainPowerGrid",
    mode: "RAISE",
    currentCommand: "SyncScreenAndCommunication/switch/DG2",
    state: {
      0: false,
      1: true,
    },
  },
  // DG3调速开关 降
  5: {
    key: "DG3SpeedSwitchLower",
    nodeId: "knob_K07_3",
    targetId: "mainPowerGrid",
    mode: "LOWER",
    currentCommand: "SyncScreenAndCommunication/switch/DG3",
    state: {
      0: false,
      1: true,
    },
  },
  //  DG3调速开关 升
  6: {
    key: "DG3SpeedSwitchRaise",
    nodeId: "knob_K07_3",
    targetId: "mainPowerGrid",
    mode: "RAISE",
    currentCommand: "SyncScreenAndCommunication/switch/DG3",
    state: {
      0: false,
      1: true,
    },
  },
  // 同步选择OFF
  7: {
    key: "SyncSelectOFF",
    nodeId: "knob_K07_4",
    targetId: "mainPowerGrid",
    mode: "OFF",
    currentCommand: "SyncScreenAndCommunication/switch/synchronizeSelection",
    state: {
      0: false,
      1: true,
    },
  },
  // 同步选择DG1
  8: {
    key: "SyncSelectDG1",
    nodeId: "knob_K07_4",
    targetId: "mainPowerGrid",
    mode: "DG1",
    currentCommand: "SyncScreenAndCommunication/switch/synchronizeSelection",
    state: {
      0: false,
      1: true,
    },
  },
  // 同步选择DG2
  9: {
    key: "SyncSelectDG2",
    nodeId: "knob_K07_4",
    targetId: "mainPowerGrid",
    mode: "DG2",
    currentCommand: "SyncScreenAndCommunication/switch/synchronizeSelection",
    state: {
      0: false,
      1: true,
    },
  },
  // 同步选择DG3
  10: {
    key: "SyncSelectDG3",
    nodeId: "knob_K07_4",
    targetId: "mainPowerGrid",
    mode: "DG3",
    currentCommand: "SyncScreenAndCommunication/switch/synchronizeSelection",
    state: {
      0: false,
      1: true,
    },
  },
  // 控制模式选择SEMI
  11: {
    key: "ControlModeSEMI",
    nodeId: "knob_K07_5",
    targetId: "mainPowerGrid",
    mode: "SEMI",
    currentCommand: "SyncScreenAndCommunication/switch/mode",
    state: {
      0: false,
      1: true,
    },
  },
  // 控制模式选择MANU
  12: {
    key: "ControlModeMANU",
    nodeId: "knob_K07_5",
    targetId: "mainPowerGrid",
    mode: "MANUAL",
    currentCommand: "SyncScreenAndCommunication/switch/mode",
    state: {
      0: false,
      1: true,
    },
  },
  // 控制模式选择AUTO
  13: {
    key: "ControlModeAUTO",
    nodeId: "knob_K07_5",
    targetId: "mainPowerGrid",
    mode: "AUTO",
    currentCommand: "SyncScreenAndCommunication/switch/mode",
    state: {
      0: false,
      1: true,
    },
  },
  // 备机选择G1-2-3
  14: {
    key: "standbySelection123",
    nodeId: "knob_K07_6",
    targetId: "mainPowerGrid",
    mode: "G1-2-3",
    currentCommand: "SyncScreenAndCommunication/knob/backupAircraft",
    state: {
      0: false,
      1: true,
    },
  },
  // 备机选择G2-3-1
  16: {
    key: "standbySelection231",
    nodeId: "knob_K07_6",
    targetId: "mainPowerGrid",
    mode: "G2-3-1",
    currentCommand: "SyncScreenAndCommunication/knob/backupAircraft",
    state: {
      0: false,
      1: true,
    },
  },
  // 备机选择G3-1-2
  15: {
    key: "standbySelection312",
    nodeId: "knob_K07_6",
    targetId: "mainPowerGrid",
    mode: "G3-1-2",
    currentCommand: "SyncScreenAndCommunication/knob/backupAircraft",
    state: {
      0: false,
      1: true,
    },
  },
  // 电压表OFF
  17: {
    key: "voltageMeterOFF",
    nodeId: "knob_K07_7",
    targetId: "meter_K07_8",
    mode: "OFF",
    currentCommand: "SyncScreenAndCommunication/switch/voltageMeter",
    state: {
      0: false,
      1: true,
    },
  },
  // 电压表BUS
  18: {
    key: "voltageMeterBUS",
    nodeId: "knob_K07_7",
    targetId: "meter_K07_8",
    mode: "BUS",
    currentCommand: "SyncScreenAndCommunication/switch/voltageMeter",
    state: {
      0: false,
      1: true,
    },
  },
  // 电压表SHORE
  19: {
    key: "voltageMeterSHORE",
    nodeId: "knob_K07_7",
    targetId: "meter_K07_8",
    mode: "SHORE",
    currentCommand: "SyncScreenAndCommunication/switch/voltageMeter",
    state: {
      0: false,
      1: true,
    },
  },
}

// 硬件转软件协议
function hardwareToSoft(id, value, type) {
  if (type !== 1) {
    return null
  }
  let recvMapData = recvMap[id]

  // 如果找不到则直接return null
  if (!recvMapData) {
    return null
  }

  if (id >= 7 && value === 0) return null

  let nodeId = recvMapData.nodeId
  let targetId = recvMapData.targetId
  let mode = recvMapData.mode
  let currentCommand = recvMapData.currentCommand

  let state = recvMapData.state[value]

  let json = {
    nodeId,
    targetId,
    mode,
    currentCommand,
    state,
  }

  return json
}

export default {
  hardwareToSoft,
}
